import axios from '../axiosInstance';
import type { UpdateCourseCategoryPayload, UpdateCourseCategoryResponse } from './types';

/**
 * Update a course category
 * PUT /api/learning-center/course-categories/:id
 */
export const updateCourseCategory = async (
  id: number,
  payload: UpdateCourseCategoryPayload
): Promise<UpdateCourseCategoryResponse> => {
  const response = await axios.put<UpdateCourseCategoryResponse>(
    `/api/learning-center/course-categories/${id}`,
    payload
  );
  return response.data;
};
